import { mappableIdZodSchema } from "@@/shared/resource-maps/mappable-id";
import { resourceMapIdZodSchema } from "@@/shared/resource-maps/resource-map-id";
import { z } from "zod";
import { resourceIdZodSchema } from "./resource-id";

const resourceMapMapZodRecord = z.record(
    mappableIdZodSchema,
    resourceIdZodSchema,
);
type ResourceMapMap = z.infer<typeof resourceMapMapZodRecord>;

const resourceMapConnectionZodSchema = z.object({
    resourceMapId: resourceMapIdZodSchema,
    resourceMapMap: resourceMapMapZodRecord.optional(),
});
type ResourceMapConnection = z.infer<typeof resourceMapConnectionZodSchema>;

export { resourceMapConnectionZodSchema, resourceMapMapZodRecord };
export type { ResourceMapConnection, ResourceMapMap };
